module.exports = __webpack_public_path__ + "img/pdf.8ee0fc4d.png";